const KeyLine = ({ testId = 'keyline' }) => {
  return (
    <div className="pt-1">
      <div className="border-t-1 border-(--keyline-color)" data-testid={testId} />
    </div>
  );
};

export default KeyLine;
